import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

// Verrou d'édition : prévient si un autre utilisateur a déjà ouvert ce document.
export const useDocLock = (kind, id, active, onLocked) => {
  const cb = useRef(onLocked);
  cb.current = onLocked;
  useEffect(() => {
    if (!active || !id) return;
    let alive = true, timer;
    const acquire = () => api.post(`/locks/${kind}/${id}`).catch((e) => {
      if (!alive) return;
      if (e.response?.status === 409) { toast.warning(errMsg(e), { duration: 6000 }); cb.current?.(); }
    });
    acquire();
    timer = setInterval(acquire, 60000);
    return () => { alive = false; clearInterval(timer); api.delete(`/locks/${kind}/${id}`).catch(() => {}); };
  }, [kind, id, active]);
};
